import { apiUrl2, apiUrl } from '../../../settings'

export const getCanadaApplicationsListUrl = () => {
  return apiUrl2 + '/canada-application-list'
}
export const callStatusChangesUrl = () => {
  return apiUrl + '/api/updateGicCallStatus'
}